module.exports = __webpack_public_path__ + "static/fonts/roboto-v32-cyrillic_cyrillic-ext_latin_latin-ext-700.807caf4.woff";